<template>
  <el-dialog
    title="计算公式"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    append-to-body
    class="dialog"
    width="800px"
  >
    <div>
      <!-- 计费模式 --->
      <div class="m-b-16">
        <strong>{{
          billingModelDict.translate(chargeInfo.billingModel).label || '-'
        }}</strong>
      </div>

      <!---计费模式为：固定值---->
      <div
        v-if="chargeInfo.billingModel == billingModelDict.FIXED_FORMULA.value"
      >
        <div class="exp-fixed">
          <span v-for="(item, index) in chargeInfo.fixedExpList" :key="index">
            {{ item.title }}
            <strong
              v-if="item.type === expTypeDict.CUSTOM.value && item.value"
              class="exp-value"
            >(值：{{ item.value }})</strong>
          </span>
        </div>
      </div>

      <!--------计费模式为：区间计费设置  或 累计计费设置--------->
      <!-- 计费基准值: 用以确认哪个值作为区间划分指标  -->
      <div
        v-if="chargeInfo.billingModel != billingModelDict.FIXED_FORMULA.value"
        class="table-width"
      >
        <el-table
          border
          :data="chargeInfo.itemList"
          size="medium"
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column
            :label="`${baseIndexDict.translate(chargeInfo.sectionMatchQuota).label || ''}区间`"
            align="left"
          >
            <template slot-scope="{ row }">
              <span>{{
                Number(row.sectionEnd) === 0
                  ? `> ${row.sectionStart}`
                  : `${row.sectionStart} - ${row.sectionEnd}`
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计算公式">
            <template slot-scope="{ row }">
              <span
                v-for="(item, index) in row.expList"
                :key="index"
                class="mt5"
              >
                {{ item.title }}
                <span
                  v-if="item.type === expTypeDict.CUSTOM.value && item.value"
                  class="exp-value"
                >(值：{{ item.value }})</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {
  billingModelDict,
  expTypeDict,
  baseIndexDict
} from '@/dictionary/company'

import { getChargeItemDetailApi } from '@/api/company'
export default {
  props: {
    configObj: {
      type: Object,
      default: () => ({
        configId: '',
        templateId: ''
      })
    }
  },

  data() {
    return {
      billingModelDict,
      expTypeDict,
      baseIndexDict,

      visible: false,
      chargeInfo: {}
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    open() {
      this.visible = true
      this.getConfigDetail()
    },

    /**
     * 获取公式详情
     */
    async getConfigDetail() {
      try {
        const _data = await getChargeItemDetailApi(this.configObj)
        this.chargeInfo = _data.data || {}
      } catch (error) {
        this.$message.error(error.message)
      }
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.visible = false
    }
  }
}
</script>
